import { render, staticRenderFns } from "./bibliometric_details.vue?vue&type=template&id=033d08b8&scoped=true"
import script from "./bibliometric_details.vue?vue&type=script&lang=js"
export * from "./bibliometric_details.vue?vue&type=script&lang=js"
import style0 from "./bibliometric_details.vue?vue&type=style&index=0&id=033d08b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d08b8",
  null
  
)

export default component.exports